export const aboutInfo = {
  brandName: '女性私密健康指南',
  tagline: '科学、温暖、不羞耻的女性健康知识平台',
  introduction: '我们是一支由妇科医生、健康科普作者和女性健康倡导者组成的团队，致力于为中国女性提供科学、准确、易懂的私密健康知识。我们相信，了解自己的身体是每个女性的权利，谈论私密健康不应该是一件令人羞耻的事情。',
  mission: '消除女性健康知识的信息鸿沟，让每一位女性都能自信地了解、爱护自己的身体，不再因为"不好意思"而延误就医或错误护理。',
  values: [
    { title: '科学严谨', description: '所有内容均由专业医生审核，确保信息准确可靠' },
    { title: '温暖亲和', description: '用温暖亲切的语言传递专业知识，让阅读轻松无压力' },
    { title: '去羞耻化', description: '坦然讨论私密健康话题，帮助女性战胜羞耻感' },
    { title: '实用导向', description: '提供可操作的护理建议和就医指导，真正帮到每一位读者' },
  ],
  stats: [
    { value: '50万+', label: '每月阅读量' },
    { value: '200+', label: '原创科普文章' },
    { value: '98%', label: '读者好评率' },
    { value: '15位', label: '专家顾问团队' },
  ],
  team: [
    { name: '李医生', role: '妇产科主任医师', description: '三甲医院妇产科工作20年，擅长妇科感染性疾病诊治' },
    { name: '王老师', role: '健康科普主编', description: '前医学杂志编辑，专注女性健康科普写作10年' },
    { name: '张博士', role: '微生物学研究员', description: '研究方向为女性生殖道微生态，发表SCI论文30余篇' },
    { name: '陈顾问', role: '心理咨询师', description: '专注于女性身心健康领域，帮助女性建立积极的身体认知' },
  ],
  contact: {
    email: 'hello@womens-health-guide.com',
    wechat: 'womens_health_guide',
    address: '中国上海市浦东新区陆家嘴金融区',
    phone: '400-123-4567',
  },
};

export const testimonials = [
  {
    name: '小雅',
    age: 28,
    content: '以前对这些问题总是不好意思问，这个网站让我学到了很多有用的知识。现在终于知道什么是正常的、什么需要看医生了。',
    location: '北京',
  },
  {
    name: '静怡',
    age: 35,
    content: '生了宝宝之后分泌物一直不太正常，看了文章才知道可能是菌群失调，去医院检查后果然是这样。感谢专业的科普！',
    location: '上海',
  },
  {
    name: '雨桐',
    age: 22,
    content: '大学生的性教育太缺失了，这个网站帮我了解了很多学校里学不到但每个女生都应该知道的知识。',
    location: '广州',
  },
  {
    name: '思琪',
    age: 42,
    content: '更年期后身体变化很大，这个网站的内容涵盖了各个年龄段的女性健康问题，非常全面，推荐给了身边所有姐妹。',
    location: '深圳',
  },
];